import { BeneficiaryModifiedDiscrepancy } from '@approvalmax/types';
import { ColumnDefinition, Flex, Table, Text } from '@approvalmax/ui/src/components';
import { CircleAlertIcon } from '@approvalmax/ui/src/icons';

import { messages } from './ChangedBeneficiariesPopupContent.messages';

export const columns: ColumnDefinition<BeneficiaryModifiedDiscrepancy & { id: string }>[] = [
    {
        id: 'beneficiary',
        name: messages.beneficiary,
        spacing: '8',
        value: (li) => li.beneficiaryName,
    },
    {
        id: 'discrepancy',
        name: messages.discrepancy,
        spacing: '8',
        cellComponent: (props) => (
            <Table.Cell {...props}>
                <Flex spacing='4'>
                    <CircleAlertIcon size='12' color='brandDext90' />

                    <div>
                        {props.item.modifiedProperties.map((property) => (
                            <Text font='label' fontSize='small' fontWeight='regular' key={property.value}>
                                - {property.name}
                            </Text>
                        ))}
                    </div>
                </Flex>
            </Table.Cell>
        ),
    },
];
